import React from 'react'
import ReactPlayer, { ReactPlayerProps } from 'react-player'

export const VideoPlayer = (props: ReactPlayerProps) => (
  <ReactPlayer {...props} />
)
